export enum BasicInputTypeEnum {
    TEXT = 'text',
    EMAIL = 'email',
    NUMBER = 'number',
    PASSWORD = 'password',
    TEL = 'tel',
    DATE = 'date',
    TIME = 'time',
    URL = 'url',
}
